module.exports = __webpack_public_path__ + "static/img/about2.ca2591b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about2.png
// module id = LZ2M
// module chunks = 1